import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Role } from '../common/models/role.model';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  private _baseUrl = 'roles/';

  constructor(private _apiService: ApiService) {}

  /**
   * All roles, active and retired, sorted by name. Not paginated.
   */
  list(): Observable<Role[]> {
    return this._apiService.get<Role[]>(this._baseUrl);
  }

  create(body: { code: string; name: string; description: string }): Observable<Role> {
    return this._apiService.post<Role>(this._baseUrl, body);
  }

  /**
   * `code` is immutable once created - the API rejects any attempt to change it.
   */
  update(id: string, body: Partial<{ name: string; description: string }>): Observable<Role> {
    return this._apiService.patch<Role>(`${this._baseUrl}${id}/`, body);
  }

  /**
   * Roles are retired rather than deleted: a role assigned to any user cannot be removed
   * (User.role is PROTECT, so DELETE answers 409). Retiring keeps existing users valid
   * while hiding the role from pickers.
   */
  setActive(id: string, isActive: boolean): Observable<Role> {
    return this._apiService.patch<Role>(`${this._baseUrl}${id}/`, { is_active: isActive });
  }
}
